import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CalendarIcon, ClipboardListIcon, ShoppingCartIcon } from 'lucide-react';
const deliverables = [{
  icon: BookOpenIcon,
  title: 'La Guía Maestra "El Detox Invisible"',
  description: 'El manual paso a paso para limpiar tu entorno hormonal.',
  iconBg: 'bg-blush',
  iconColor: 'text-blush-ink'
}, {
  icon: CalendarIcon,
  title: 'Protocolo de 14 Días',
  description: 'Plan de acción diario para resetear tu carga tóxica sin estrés.',
  iconBg: 'bg-sage',
  iconColor: 'text-sage-ink'
}, {
  icon: ClipboardListIcon,
  title: 'Checklist de Cocina y Baño',
  description: 'Lista exacta de qué tirar y por qué sustituirlo.',
  iconBg: 'bg-sky-pastel',
  iconColor: 'text-sky-ink'
}, {
  icon: ShoppingCartIcon,
  title: 'Lista de Compra Segura',
  description: 'Marcas libres de tóxicos disponibles en cualquier supermercado de EE.UU.',
  iconBg: 'bg-beige',
  iconColor: 'text-accent'
}];
export function Deliverables() {
  return <section className="w-full bg-blush-soft py-20 md:py-28" data-id="element-24">
      <div className="max-w-6xl mx-auto px-6 md:px-8" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="text-center mb-14" data-id="element-26">
          <span className="inline-block bg-white text-blush-ink text-xs font-semibold tracking-widest uppercase px-4 py-1.5 rounded-full mb-4" data-id="element-27">
            Qué obtienes
          </span>
          <h2 className="font-serif text-3xl md:text-5xl text-ink" data-id="element-28">
            Todo lo que necesitas en un solo lugar
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-29">
          {deliverables.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          ease: 'easeOut',
          delay: index * 0.1
        }} className="flex gap-5 bg-white p-6 md:p-7 rounded-2xl shadow-sm" data-id="element-30">
              <div className={`flex-shrink-0 inline-flex items-center justify-center w-14 h-14 rounded-full ${item.iconBg}`} data-id="element-31">
                <item.icon className={`w-6 h-6 ${item.iconColor}`} data-id="element-32" />
              </div>
              <div data-id="element-33">
                <h3 className="font-serif text-xl text-ink mb-2" data-id="element-34">
                  {item.title}
                </h3>
                <p className="text-ink-soft leading-relaxed" data-id="element-35">
                  {item.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="max-w-md mx-auto" data-id="element-36">
          <img src="https://cdn.magicpatterns.com/uploads/fV7KR41b8GeviY8My2CSqg/fertilidad_producto_imagen_organica.png" alt="El Detox Invisible - Paquete completo digital" className="w-full h-auto rounded-2xl shadow-xl" data-id="element-37" />
        </motion.div>
      </div>
    </section>;
}